// extracted by mini-css-extract-plugin
module.exports = {"bodyWrapper":"AccountFavoriteButton_bodyWrapper__2QSMV","signUpButton":"AccountFavoriteButton_signUpButton__61f42"};